import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { updateRolesSettings, createRole } from "@api/settings/roles"
import { can, MODIFY_USERS_AND_ROLES } from "@src/helpers/authorization"

const Header = ({ updateRolesSettings, createRole, search, canModify }) => (
  <div className='flex items-center'>
    <h4>Roles</h4>
    <div className='flex items-center justify-end flex-auto'>
      <input
        value={search}
        className='cs-input'
        placeholder='Search for a role...'
        onChange={e => updateRolesSettings({ search: e.target.value })}/>
      {canModify && (
        <button onClick={() => createRole()} className='ml2 cs-button'>
          Create New Role
        </button>
      )}
    </div>
  </div>
)

Header.propTypes = {
  updateRolesSettings: PropTypes.func.isRequired,
  createRole: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  canModify: PropTypes.bool.isRequired
}

const mapStateToProps = (state, ownProps) => ({
  search: state.settings.roles.search,
  canModify: can(state.user, [MODIFY_USERS_AND_ROLES])
})

const mapDispatchToProps = dispatch => ({
  updateRolesSettings: bindActionCreators(updateRolesSettings, dispatch),
  createRole: bindActionCreators(createRole, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
